<template>
    <div>
        <div class="card">
            <div class="card-header">
                <h5>Buku Besar Pembantu</h5>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                          <label for="contact" class="col-sm-3 col-form-label text-left">Contact</label>
                          <div class="col-sm-9">
                              <!-- <input type="text" class="form-control" v-model="account_code"/> -->
                            <v-select :options="contactSelect" :reduce="contact => contact.meta.code" label="contact" v-model="contact"/>
                          </div>
                      </div>
                      <div class="form-group row">
                          <label for="month" class="col-sm-3 col-form-label text-left">Date</label>
                          <div class="col-sm-9">
                            <div class="row">
                              <div class="col-6"><input type="text" class="form-control" v-model="month"/></div>
                              <div class="col-6"><input type="text" class="form-control" v-model="year"/></div>
                            </div>
                          </div>
                      </div>
                      <div class="form-group row">
                          <label for="year" class="col-sm-3 col-form-label text-left">&nbsp;</label>
                          <div class="col-sm-9">
                              <button type="button" class="btn btn-primary" @click="refreshList">Search</button>
                          </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row">
                          <label for="account_code" class="col-sm-3 col-form-label text-left">Saldo Awal</label>
                          <div class="col-sm-9">
                              <input type="text" class="form-control" v-model="saldoAwal" v-money="money"/>
                          </div>
                      </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <table class="table table-item mb-0 table-sm table-striped table-hover">
                            <thead>
                                <th>Date</th>
                                <th>Journal No</th>
                                <th>Remark</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>Saldo</th>
                            </thead>
                            <tbody>
                                <tr v-for="j in journal" :key="j.id">
                                    <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td>
                                      <span @click="editJournal(j.jid)"><b>{{ j.journal_code }}</b></span>
                                    </td>
                                    <td>{{ j.remark }}</td>
                                    <td class="text-right">{{ j.debit | currency }}</td>
                                    <td class="text-right">{{ j.credit | currency }}</td>
                                    <td class="text-right">{{ j.saldo }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right"><h5><b>{{ saldoAkhir }}</b></h5></td>
                              </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer"></div>
        </div>
    </div>
</template>
<script>
import Axios from 'axios'
import { financeUrl, getHeader } from '../../config'
import { mapState } from 'vuex'
export default {
  name: 'BukuBesarPembantu',
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      contact: null,
      month: date.getMonth() + 1,
      year: date.getFullYear(),
      saldoAwal: 0,
      saldoAkhir: null,
      journal: [{
        no: null,
        jid: null,
        id: null,
        journal_code: null,
        account_code: null,
        remark: null,
        debit: 0,
        credit: 0,
        saldo: null,
        branch_no: null,
        journal_date: null,
        account: {
          id: null,
          type_code: null,
          account_code: null,
          account_name: null,
          notes: null,
          account_balance: null,
          group_id: null,
          method: null
        }
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  mounted () {
    this.refreshList()
    this.$store.dispatch('getJournalContacts')
  },
  computed: {
    ...mapState({
      contactList: state => state.journals.journalContacts
    }),
    contactSelect: function () {
      var loop = []
      for (let i = 0; i < this.contactList.length; i++) {
        var obj = {
          contact: this.contactList[i].contact_no + ' - ' + this.contactList[i].contact_name,
          meta: {
            code: this.contactList[i].contact_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    editJournal: function (id) {
      alert(id)
    },
    refreshList: function () {
      var url = financeUrl + '/buku-besar-pembantu?contact=' + this.contact + '&month=' + this.month + '&year=' + this.year
      console.log(url)
      Axios.get(url, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.journal = response.data.data
          this.saldoAwal = response.data.saldoAwal
          this.saldoAkhir = response.data.saldoAkhir
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    }
  }
}
</script>
